import { useParams } from "react-router-dom";
import List from "components/list";
import CreateItemButton from "components/buttons/create";
import HeaderPortal from "components/portal/header-portal";
import { PermissionControlledInput } from "permissions/components/input";
import { DateCell } from "@/components/date/cell";
import { EmployeeUserCell } from "components/cell/employee/cell";
import { getdirectusUserFields } from "components/user/config";
import { CHALLENGES_COLLECTION } from "./constants";

const TruncatedCell = ({ getValue }) => (
  <div className="max-w-md truncate">{getValue()}</div>
);

export default function JobChallenges() {
  const { jobId } = useParams();
  const columns = [
    {
      id: "challenge",
      header: "Challenge",
      accessorKey: "challenge",
      cell: TruncatedCell,
    },
    {
      id: "solution",
      header: "Solution",
      accessorKey: "solution",
      cell: TruncatedCell,
    },
    {
      id: "date_created",
      header: "Created on",
      accessorKey: "date_created",
      cell: DateCell,
    },
    {
      id: "user_created",
      header: "Created by",
      accessorKey: "user_created",
      cell: EmployeeUserCell,
    },
  ];
  const fields = [
    "id",
    "challenge",
    "solution",
    "date_created",
    getdirectusUserFields("user_created"),
  ];
  return (
    <div className="flex-1 w-full">
      <HeaderPortal>
        <PermissionControlledInput
          rule="create:*"
          collection={CHALLENGES_COLLECTION}
          showWhenDisabled={false}
        >
          <CreateItemButton href>Challenge</CreateItemButton>
        </PermissionControlledInput>
      </HeaderPortal>
      <List
        title="Challenges"
        endPoint={CHALLENGES_COLLECTION}
        storageKey={`job-challenges-${jobId}`}
        showSearch={false}
        filters={{ job: { id: { _eq: jobId } } }}
        columns={columns}
        meta={{ fields }}
        href={(item) => `/work/jobs/${jobId}/challenges/${item.id}`}
      />
    </div>
  );
}
